import { TabItem } from '../../components/components.interfaces';
import PerformanceView from './performance/performance.view';
import { TTranslateTextType } from 'src/hooks/useTranslationHook';

export const analyticsSubRouteIds = ['performance', 'custom-dashboards'];

export const getAnalyticsTabIndex = (pathname: string) => {
  const analyticsTabsIndexObject = {
    performance: 0,
    'custom-dashboards': 1,
  };

  const tabIndex =
    analyticsTabsIndexObject[pathname as keyof typeof analyticsTabsIndexObject];
  return tabIndex;
};

export const getAnalyticsSubRouteId = (index: number) =>
  analyticsSubRouteIds[index];

export const getAnalyticsViewTabMenuItems = (
  translateText: TTranslateTextType
): TabItem[] => {
  return [
    {
      label: translateText('analytics.tabs.performance'),
      onClickHandler: (val) => {
        // Will be handled by parent component
      },
      tabPanel: <PerformanceView />,
    },
    {
      label: translateText('analytics.tabs.customDashboards'),
      onClickHandler: (val) => {
        // Will be handled by parent component
      },
      tabPanel: translateText('analytics.customDashboards.description'),
    },
  ];
};
